import { useCallback, useEffect, useState } from "react";
import { useCreatePartnerCodeGroupMutation } from "../../Hooks/useCreatePartnerGroupMutation";
import PartnerCodeGroupFormModal from "../PartnerCodeGroupForm/PartnerCodeGroupForm";

function CreatePartnerCodeGroupModel({
  createPartnerCodeGroupModalOpen,
  closeCreatePartnerCodeGroupModal,
  setToast,
  refetch,
  codeGroupType,
}) {
  const [partnerCodeGroupData, setPartnerCodeGroupData] = useState({
    codeGroupType,
  });

  // Sync codeGroupType when prop changes
  useEffect(() => {
    if (codeGroupType) {
      setPartnerCodeGroupData((prev) => ({ ...prev, codeGroupType }));
    }
  }, [codeGroupType]);
  const [createPartnerCodeGroupMutation, { loading }] =
    useCreatePartnerCodeGroupMutation();

  const handleCreatePartnerCodeGroup = useCallback(() => {
    const resetForm = () => {
      setPartnerCodeGroupData({});
      closeCreatePartnerCodeGroupModal();
    };

    const onSuccess = () => {
      setToast({
        open: true,
        type: "success",
        title: `Code Group ${partnerCodeGroupData?.name} Created!`,
        description: "You have just published a partner Group!",
      });
      resetForm();
      refetch();
    };

    const onFailure = (error) => {
      setToast({
        open: true,
        type: "error",
        title: `Error creating Code Group: ${partnerCodeGroupData?.name}`,
        description: error?.message || "",
      });
    };

    createPartnerCodeGroupMutation(onSuccess, onFailure, partnerCodeGroupData);
  }, [
    closeCreatePartnerCodeGroupModal,
    createPartnerCodeGroupMutation,
    partnerCodeGroupData,
    refetch,
    setToast,
  ]);

  return (
    <PartnerCodeGroupFormModal
      isOpen={createPartnerCodeGroupModalOpen}
      toggleCreatePartnerCodeModal={closeCreatePartnerCodeGroupModal}
      closeModal={closeCreatePartnerCodeGroupModal}
      partnerCodeGroupData={partnerCodeGroupData}
      setPartnerCodeGroupData={setPartnerCodeGroupData}
      handleMutation={handleCreatePartnerCodeGroup}
      loading={loading}
      title="Create"
      isEditMode={false}
      codeGroupType={codeGroupType}
    />
  );
}

export default CreatePartnerCodeGroupModel;
